export default (url, callBack) => {
  return fetch(url, { mode: "cors" })
    .then(() => {
      if (callBack && typeof callBack === "function") {
        callBack(true);
      } else {
        return true;
      }
    })
    .catch(() => {
      if (callBack && typeof callBack === "function") {
        callBack(false);
      } else {
        return false;
      }
    });
};
